import { communityUpdateFilterCriteria } from "../../../actions/community-actions"
import {
    autocompleteCommunityLabelsRequest,
    autocompleteCommunitySystemLabelsRequest,
    autocompleteCommunitiesRequest,
    autocompleteDimensionsRequest,
    autocompleteProjectsRequest,
    autocompleteTopicsRequest,
    autocompleteUsersRequest
} from "../../../actions/autocomplete-actions"

import buildItemConnector from "../../common/build-item-connector"

import CommunityFilterForm from "./CommunityFilterForm"

export default buildItemConnector(
    "communities",
    true,
    communityUpdateFilterCriteria,
    null,
    {
        onLabelsSearch: autocompleteCommunityLabelsRequest,
        onSystemLabelsSearch: autocompleteCommunitySystemLabelsRequest,
        onTopicsSearch: autocompleteTopicsRequest,
        onDimensionsSearch: autocompleteDimensionsRequest,
        onProjectsSearch: autocompleteProjectsRequest,
        onCommunitiesSearch: autocompleteCommunitiesRequest,
        onUsersSearch: autocompleteUsersRequest
    }
)(CommunityFilterForm)
